import React from 'react';
import { Card } from '@/components/ui/card';
import { ClipboardCheck, ArrowUpRight, Minus, Bug } from 'lucide-react';

const C = { navy: '#0D1B2A', blue: '#1A4C7C', slate: '#5C6B7A', green: '#1D9E75', amber: '#B27516', red: '#E24B4A', bg: '#F5F7FA' };

export const FmiReviewCard = ({ review, categories, total, totalMax }) => {
  if (!review) return null;
  const prev = review.previous || {};
  const delta = Math.round((total - (prev.total || 0)) * 10) / 10;
  return (
    <Card className="rounded-md overflow-hidden" style={{ border: '1px solid rgba(136,150,168,0.14)' }} data-testid="fmi-review">
      <div className="p-4 flex flex-wrap items-center gap-2 border-b" style={{ borderColor: 'rgba(136,150,168,0.1)' }}>
        <ClipboardCheck className="w-4 h-4" style={{ color: C.green }} />
        <h3 className="text-xs font-semibold uppercase tracking-wider" style={{ color: C.navy }}>Latest re-grade — v{review.version} · {review.date}</h3>
        <span className="ml-auto text-[11px] font-mono" style={{ color: delta >= 0 ? C.green : C.red }} data-testid="fmi-review-delta">
          {prev.total} → {total} of {totalMax} ({delta >= 0 ? '+' : ''}{delta})
        </span>
      </div>
      <div className="p-4 grid grid-cols-1 lg:grid-cols-3 gap-4">
        <div>
          <p className="text-[10px] uppercase tracking-wider font-semibold mb-1" style={{ color: C.blue }}>By category</p>
          {categories.map(c => {
            const p = (prev.categories || {})[c.id];
            const d = p === undefined ? null : Math.round((c.score - p) * 10) / 10;
            return (
              <div key={c.id} className="flex items-center justify-between text-[11px] py-0.5 border-t border-[rgba(136,150,168,0.08)]" data-testid={`fmi-review-cat-${c.id}`}>
                <span style={{ color: C.navy }}>{c.name}</span>
                <span className="font-mono" style={{ color: d ? C.green : C.slate }}>{p} → {c.score}{d ? ` (+${d})` : ''}</span>
              </div>
            );
          })}
          <p className="text-[10px] mt-2 leading-relaxed" style={{ color: C.slate }}>{review.method}</p>
        </div>
        <div>
          <p className="text-[10px] uppercase tracking-wider font-semibold mb-1 flex items-center gap-1" style={{ color: C.green }}><ArrowUpRight className="w-3 h-3" /> Moved ({review.moves.length})</p>
          {review.moves.map(m => (
            <p key={m.id} className="text-[11px] py-0.5 border-t border-[rgba(136,150,168,0.08)]" style={{ color: C.navy }} data-testid={`fmi-review-move-${m.id}`}>
              <span className="font-mono mr-1" style={{ color: C.slate }}>{m.id}</span><span className="font-mono font-semibold" style={{ color: C.green }}>{m.from} → {m.to}</span> · {m.why}
            </p>
          ))}
        </div>
        <div>
          <p className="text-[10px] uppercase tracking-wider font-semibold mb-1 flex items-center gap-1" style={{ color: C.amber }}><Minus className="w-3 h-3" /> Held, with the reason ({review.held.length})</p>
          {review.held.map(h => (
            <p key={h.id} className="text-[11px] py-0.5 border-t border-[rgba(136,150,168,0.08)]" style={{ color: C.navy }} data-testid={`fmi-review-held-${h.id}`}>
              <span className="font-mono mr-1" style={{ color: C.slate }}>{h.id}</span><span className="font-mono" style={{ color: C.amber }}>{h.at}/4</span> · {h.why}
            </p>
          ))}
          {review.findings?.length > 0 && (
            <>
              <p className="text-[10px] uppercase tracking-wider font-semibold mt-3 mb-1 flex items-center gap-1" style={{ color: C.red }}><Bug className="w-3 h-3" /> Findings from testing</p>
              {review.findings.map((f, i) => (
                <p key={i} className="text-[11px] py-0.5 border-t border-[rgba(136,150,168,0.08)]" style={{ color: C.navy }} data-testid={`fmi-review-finding-${i}`}>
                  <span style={{ color: C.slate }}>{f.source}:</span> {f.finding} — <span style={{ color: C.green }}>{f.disposition}</span>
                </p>
              ))}
            </>
          )}
        </div>
      </div>
    </Card>
  );
};
